/**
 * @class Connector
 */

import * as React from "react";
import { IComponent } from "./interfaces/Component";
import { components } from "./definitions";
import { Group, Circle, Image as ReactKonvaImage } from "react-konva";

import Port from "./Port";
import { IPort } from "./interfaces/ComponentDefinition";

export type Props = {
  component: IComponent;
  selectedComponentId: string | null;
  x: number;
  y: number;
  mouseIsOver: boolean;
  newConnectionInProgress: boolean;
  onPortHovered(port: IPort): void;
};

type State = {
  hovering: boolean;
  connectorCentreClicked: boolean;
  connectorImageLoaded: boolean;
};

const Options = {
  iconWidth: 20,
  iconHeight: 20
};

export default class Connector extends React.Component<Props, State> {
  state = {
    hovering: false,
    connectorCentreClicked: false,
    connectorImageLoaded: false
  };

  connectorImage: HTMLImageElement;

  componentDidMount() {
    this.connectorImage = new Image(Options.iconWidth);
    this.connectorImage.onload = () => {
      this.setState({ connectorImageLoaded: true });
    };
    this.connectorImage.src = `/assets/images/arrow-right-white.svg`;
  }

  onHoverChange = (hovering: boolean) => {
    this.setState({ hovering });
  };

  handleMouseDown = () => {
    const { onPortHovered, component } = this.props;
    const definition = components.find(
      c => component.graphComponentId === c.graphComponentId
    );
    const length = definition && definition.ports.length;
    if (length && length <= 1) {
      if (definition && length === 1) {
        const portSel = definition.ports[0];
        setTimeout(() => {
          onPortHovered(portSel);
          this.setState({ connectorCentreClicked: false });
        }, 50)
      }
    } else if (length && length > 1) {
      this.setState({ connectorCentreClicked: true });
    }
  }

  render() {
    const { component, x, y, onPortHovered, mouseIsOver, newConnectionInProgress, selectedComponentId } = this.props;
    const definition = components.find(
      c => component.graphComponentId === c.graphComponentId
    );
    if (!definition) {
      return null;
    }
    const angle = 180 / definition.ports.length;

    const selected = selectedComponentId === component.id;
    let showCircle = this.props.mouseIsOver;
    if (newConnectionInProgress) {
      showCircle = selected;
    };

    return (
      <Group x={x} y={y}>
        <Group visible={mouseIsOver || newConnectionInProgress}>
          {definition.ports.map((port, idx) => (
            <Port
              port={port}
              angle={angle}
              idx={idx}
              key={`port-${component.id}-${port.title}`}
              {...(
                this.state.connectorCentreClicked ? {
                  onHover: e => {
                    onPortHovered(e);
                    this.setState({ connectorCentreClicked: false });
                  }
                } : {
                  onHover: () => {}
                }
              )}
              visible={this.state.connectorCentreClicked || (selected && newConnectionInProgress)}
            />
          ))}
          <Group
            visible={showCircle}
            onMouseDown={this.handleMouseDown}
          >
            <Circle radius={18} fill="skyblue" stroke="white" strokeWidth={2} />
            {this.state.connectorImageLoaded && (
              <ReactKonvaImage
                image={this.connectorImage}
                offsetX={18}
                offsetY={10}
                width={Options.iconWidth}
                height={Options.iconHeight}
              />
            )}
          </Group>
        </Group>
      </Group>
    );
  }
}
